import React from "react";
import { withStyles } from '@material-ui/core';
import "./index.css"

const styles = () => ({
  icon: {
    cursor: "pointer",
  }
});

const Icon = ({ classes, stroke, onHoverColor, Component, onClick, rotate, className }) => {
  const [iconStroke, setIconStroke] = React.useState(stroke || '#333');
  const [rotateIcon, setRotate] = React.useState(false)

  const handleClick = () => {
    if (typeof onClick === "function") {
      onClick();
    }
    if (rotate) {
      setRotate(true)
    }
    setTimeout(() => {
      setRotate(false)
    }, 2000)
  }

  const onMouseEnter = () => {
    setIconStroke(onHoverColor)
  }
  const onMouseLeave = () => {
    setIconStroke(stroke || '#333')
  }
  return (
    <div className={`${classes.icon} ${rotateIcon && "rotate"} ${className}`} onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave} onClick={handleClick}>
      <Component stroke={iconStroke} fill="none" />
    </div>)
}


export default (withStyles(styles)(Icon));